import React, { useEffect, useState } from "react";
import { HiSparkles } from "react-icons/hi";
import styles from "./ProTipChat.module.css";

const PRO_TIP_MESSAGES = [
  "Our Chat Platform lets you manage and respond to conversations in one place",
  "Handle multiple conversations efficiently using our Chat Platform",
  "Assign, track, and respond to chats easily from the Chat Platform",
];

const ProTipChat = ({ onClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % PRO_TIP_MESSAGES.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="row">
      <div className="col-12 col-md-6">
        <div
          className={styles.protipPill}
          onClick={onClick}
          role="button"
          tabIndex={0}
          title={PRO_TIP_MESSAGES[currentIndex]} 
        >
          <div className={styles.protipContent}>
            <HiSparkles className={styles.protipIcon} />

            <span className={styles.protipText}>
              {PRO_TIP_MESSAGES[currentIndex]}
            </span>

            <span className={styles.protipArrow}>→</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProTipChat;
